import { render, staticRenderFns } from "./ResourceCapacitiesPage.vue?vue&type=template&id=230463b2"
import script from "./ResourceCapacitiesPage.vue?vue&type=script&lang=ts"
export * from "./ResourceCapacitiesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports